import { useMemo } from "react";
import { Box } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/react";

import { TipoContatoEnum } from "features/auth/typings/user";
import { PessoaContato } from "features/unidades/typings/unidade";
import { formatPhone } from "infra/helpers/number";

function useListagemContatoUnidadeColumns() {
  return useMemo(() => {
    return [
      {
        title: "Contato",
        render: (original: PessoaContato) => (
          <Box>
            {original.tipoContatoId === TipoContatoEnum.Telefone ||
            original.tipoContatoId === TipoContatoEnum.Celular
              ? formatPhone(original.conteudo)
              : original.conteudo}
          </Box>
        ),
      },
      {
        title: "Tipo",
        render: (original: PessoaContato) => (
          <Box>{tipoContatoNome(original.tipoContatoId)}</Box>
        ),
      },
      {
        title: "",
        render: (original: PessoaContato) => (
          <Box>
            {original.receberCobranca ? (
              <Tag variant="outline" colorScheme="blue" borderRadius="20px">
                Receber cobrança
              </Tag>
            ) : null}
          </Box>
        ),
      },
    ];
  }, []);
}

function tipoContatoNome(tipoContatoId: TipoContatoEnum) {
  switch (tipoContatoId) {
    case TipoContatoEnum.Email:
      return "Email";

    case TipoContatoEnum.Telefone:
      return "Telefone";

    case TipoContatoEnum.Celular:
      return "Celular";

    default:
      return "Outros";
  }
}

export default useListagemContatoUnidadeColumns;
